module.exports = __webpack_public_path__ + "static/oval501-7d4518ceea0dfd609fdf1b83410e3072.png";